import PropTypes from 'prop-types';
import { Box, FormControl, IconButton, Menu, MenuItem, Radio, RadioGroup, Typography, AppBar } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import React, { useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { AIADMIN_TEXT_SECONDARY } from './CommonThemes';
import Profile from '../../common/header/Profile';
import useHeaderStyles from './HeaderStyles';
import { useTenant } from './components/tenantContext/TenantContext';
import SessionManagement from '../../common/header/SessionManagement';
import { MIXPANEL_EVENTS } from '../../common/MixPanelConstants';
import { getTenantTrackingProperties, trackEvent } from './utils/mixPanelUtils';

const Header = ({ onTenantChange, userPermissionDetail, isSuperAdmin, tenantList }) => {
  const history = useHistory();
  const [anchorEl, setAnchorEl] = useState(null);
  const classes = useHeaderStyles();
  const { tenant } = useTenant();

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleTenantChange = (selectedTenantVal) => {
    trackEvent(MIXPANEL_EVENTS.TENANT_SWITCHED, {
      ...getTenantTrackingProperties(selectedTenantVal),
      previousTenantName: tenant.tenantName,
      previousTenantTitle: tenant.tenantTitle
    });
    onTenantChange(selectedTenantVal);
    history.push(`/aiadmin/${selectedTenantVal?.name}`);
    handleClose();
  };

  const tenantExists = (tenantId) => {
    if (isSuperAdmin) {
      return true;
    }
    const tenantCheck = userPermissionDetail?.tenantPermissions.some((item) => {
      if (item.tenantId) {
        return item?.tenantId === tenantId;
      }
      return true;
    });

    return tenantCheck;
  };

  return (
    <AppBar className={classes.appBar}>
      <Box component="header" className={classes.headerSection}>
        <Link to={`/aiadmin/${tenant.tenantName}`} title="Click here to go to the home page.">
          <Box component="img" src="/images/pearsonlogo.svg" alt="Title text will come" className={classes.logo} />
        </Link>
        <Box className={classes.flexAndCenter}>
          <Box className={classes.flexAndCenter}>
            <Typography className={classes.tenantAbbreviation}>{tenant.tenantTitle}</Typography>
            <IconButton onClick={handleOpen} sx={{ color: AIADMIN_TEXT_SECONDARY }}>
              <ArrowDropDownIcon />
            </IconButton>
          </Box>
          <Profile />
        </Box>

        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
          <FormControl component="fieldset" sx={{ p: 2 }}>
            <RadioGroup value={tenant.tenantId}>
              {tenantList.map(
                (item) =>
                  tenantExists(item?.tenantId) ? ( // check for tenant exist or not
                    <MenuItem key={item.tenantId} value={item.tenantId} onClick={() => handleTenantChange(item)}>
                      <Radio value={item.tenantId} />
                      {item.title}
                    </MenuItem>
                  ) : null // return null
              )}
            </RadioGroup>
          </FormControl>
        </Menu>
      </Box>
      <SessionManagement />
    </AppBar>
  );
};

Header.propTypes = {
  onTenantChange: PropTypes.func.isRequired,
  userPermissionDetail: PropTypes.array.isRequired,
  isSuperAdmin: PropTypes.bool.isRequired,
  tenantList: PropTypes.array.isRequired
};

export default Header;
